import React, { useState } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card } from 'react-bootstrap';

import { mdiEyeOffOutline } from '@mdi/js';
import FormInputs from '../../../Utils/FormInputs';

export default function ChangePassword() {
    // Account New Options
    const [inputData, setInputData] = useState({
        current_password: '',
        current_new_password: '',
        current_confirm_password: '',
    });
    const handleCngPwdInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleCngPwdSubmit = (e) => {
        e.preventDefault();
    };
    const cngPwdRows = [
        {
            columns: [
                { size: { lg: 4 }, label: 'Current Password', type: 'password', placeholder: 'Enter password...', inputIcon: mdiEyeOffOutline, name: 'current_password', id: 'currentPassword', value: inputData.current_password, errormsg: '', },
                { size: { lg: 4 }, label: 'New Password', type: 'password', placeholder: 'Enter new password...', inputIcon: mdiEyeOffOutline, name: 'current_new_password', id: 'currentNewPassword', value: inputData.current_new_password, errormsg: '', },
                { size: { lg: 4 }, label: 'Confirm Password', type: 'password', placeholder: 'Enter confirm password...', inputIcon: mdiEyeOffOutline, name: 'current_confirm_password', id: 'currentConfirmPassword', value: inputData.current_confirm_password, errormsg: '', },
            ]
        },
    ];
    const cngPwdButtons = [
        { variant: "primary", text: "Save", onClick: handleCngPwdSubmit },
        { variant: "secondary", text: "Cancel" },
    ];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>Change Password</Card.Title>
                                        <FormInputs Buttons={cngPwdButtons} rows={cngPwdRows} handleInputChange={handleCngPwdInputChange} handleSubmit={handleCngPwdSubmit} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
